import React, { FC, useEffect } from 'react';

import Payments from './Payments/Payments';
import { Item, Line, Title, Wrapper } from './subscription.style';
import { getSettings } from '../../API/settings';
import SettingsContainer from '../../layout/SettingsContainer';
import { useAppDispatch } from '../../store/hooks';

const Subscription: FC = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getSettings(null));
  }, []);

  return (
    <>
      <SettingsContainer>
        <Wrapper>
          <Title>Subscription</Title>
          <Item>
            <Payments />
          </Item>
        </Wrapper>
      </SettingsContainer>
    </>
  );
};

export default Subscription;
